import { PaymentMethod } from '@repo/common';
import { useRef } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';

import {
    useAddCustomerPaymentMutation,
    useGetCustomerByIdQuery,
} from '@/features/slice/customers/customer-api-slice';

import { IwFormRef } from '../../../components/form';
import { toastError } from '../../../utils';
import { TAddPaymentForm } from '../../cart/add-payment-form.schema';

export const useCustomerDetails = () => {
    const params = useParams();
    const id = params.id || '';
    const { data, error, isLoading, isError } = useGetCustomerByIdQuery(id);

    const paymentFormRef = useRef<IwFormRef<TAddPaymentForm>>(null);

    const [addCustomerPayment, { isLoading: isPaymentLoading }] =
        useAddCustomerPaymentMutation();

    const handleAddCustomerPayment = async (data: TAddPaymentForm) => {
        try {
            await addCustomerPayment({
                id,
                amount: data.payments?.[0]?.amount || 0,
                payment_method: data.payments?.[0]?.payment_method || '',
                transaction_id: data.payments?.[0]?.transaction_id || '',
            }).unwrap();
            paymentFormRef.current?.setValue('payments', [
                {
                    amount: 0,
                    payment_method: PaymentMethod.CASH,
                    transaction_id: '',
                },
            ]);
            toast.success('Payment added successfully');
        } catch (error) {
            toastError(error, 'Failed to add payment');
        }
    };

    return {
        data,
        error,
        isLoading,
        isError,
        handleAddCustomerPayment,
        isPaymentLoading,
        paymentFormRef,
    };
};
